"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_VALUE = exports.TYPE = void 0;
const id_1 = require("../../../utils/id");
const rich_text_1 = require("@vedalib/rich-text");
const types_1 = require("./types");
exports.TYPE = 'checkbox';
exports.DEFAULT_VALUE = {
    items: [{ label: (0, rich_text_1.textToRtValue)(''), value: (0, id_1.generateId)() }],
    type: types_1.CheckboxType.selfCheck,
    condition: types_1.CheckboxCondition.all,
    progress: types_1.CheckboxProgress.all,
};
